import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const accountTerminationRoute = createRoute({
	getParentRoute: () => clientRoute,
	path: '/accounts/$accountUuid/termination',
});
